module.exports = __webpack_public_path__ + "img/hz_26.b534cfc8.jpg";